import React, { useEffect, useState, useContext } from 'react';
import ModuleTitle from '../../../module-title';
import { Form, Select, Cascader, message } from 'antd';
import FilterBoxes from '@/components/filter-boxes';
import apis from '@/pages/mvp-panel/participant-data/apis';
import IconTip from '@/components/icon-tip';
import './index.less';
import SkuEffect from '../sku-effect';
import UVEffect from '../uv-effect';
import ProviderUserTypeInfo from '../../../../provider-userType-info';
import TreeSelectDepartment, { validateSelectMax } from '@/form-component/tree-select-department';
import { formatPrice } from '@/common/utils';
const CoreIndicators = (props) => {
  const value = useContext(ProviderUserTypeInfo);
  const [selectCode, setSelectCode] = useState({});
  const [form] = Form.useForm();
  const [formItemState, setFormItemState] = useState({
    shopId: false,
    catdCd: false,
    brandCode: false,
  });
  const [data, setData] = useState({
    brandList: [],
    shopList: [],
    cateTree: [],
  });
  const [conditions, setConditions] = useState({
    itemFirstCateCd: ['全部'],
    itemSecondCateCd: [],
    itemThirdCateCd: [],
    brandCode: '全部',
    shopId: '全部',
  });

  //吸顶筛选结果更新
  useEffect(() => {
    setConditions((conditions) =>
      Object.assign(
        {},
        conditions,
        { planCode: props.planCode },
        { period: props.period },
        {
          startTime: props.startTime,
        },
        { endTime: props.endTime },
        {
          platformCd: props.platformCd,
        },
        {
          realTimeData: props.realTimeData,
        },
        {
          ...value,
        }
      )
    );
  }, [props.planCode, props.period, props.startTime, props.endTime, props.realTimeData, props.platformCd, value]);

  const [dataSource, setDataSource] = useState({});
  useEffect(() => {
    if (!props.planCode) return;
    apis.queryBrandAndShopList({ planCode: props.planCode, ...value }).then((res) => {
      const {
        ret,
        data: { brandList = [], shopList = [], cateTree = [] },
      } = res;
      if (ret === '0') {
        setData({ brandList, shopList, cateTree });
      }
    });
  }, [props.planCode, value]);

  useEffect(() => {
    console.log('走了吗', conditions);
    if (!conditions.userType || !conditions.planCode) return;
    apis.queryIndexOngoingInfo(conditions).then((res) => {
      const { ret, data, msg } = res;
      if (ret === '0') {
        setDataSource(data);
      } else {
        message.error(msg);
      }
    });
  }, [conditions]);

  const onValuesChange = (changedValues, allValues) => {
    const arrValues = Object.values(allValues).filter((item) => {
      if (item instanceof Array) {
        return item.length > 0;
      }
      return item !== undefined;
    });
    if (arrValues.length === 1) {
      setFormItemState({
        shopId: allValues.shopId ? false : allValues.catdCd && allValues.catdCd.length > 0 ? false : true,
        catdCd: allValues.catdCd && allValues.catdCd.length > 0 ? false : allValues.shopId ? false : true,
        brandCode: allValues.brandCode ? false : true,
      });
    } else if (arrValues.length === 2) {
      setFormItemState({
        shopId: false,
        catdCd: false,
        brandCode: true,
      });
    } else {
      setFormItemState({
        shopId: false,
        catdCd: false,
        brandCode: false,
      });
    }
  };

  const onFinish = (val) => {
    console.log('查询多', val);
    const shopId = val.shopId || '全部';
    const brandCode = val.brandCode || '全部';
    let firstList = [];
    let secondList = [];
    let thirdList = [];
    if (val.catdCd && val.catdCd.length) {
      val.catdCd.map((item) => {
        if (item.length === 1) {
          firstList.push(item[0]);
        }
        if (item.length === 2) {
          secondList.push(item[1]);
        }
        if (item.length === 3) {
          thirdList.push(item[2]);
        }
      });
    } else {
      firstList = ['全部'];
      secondList = [];
      thirdList = [];
    }

    setConditions({
      ...conditions,
      shopId,
      brandCode,
      itemFirstCateCd: firstList,
      itemSecondCateCd: secondList,
      itemThirdCateCd: thirdList,
    });
  };

  return (
    <div className="core-indicators-bg">
      <ModuleTitle title={props.title} desc="仅店铺和品类维度可同时筛选，其他均为单维度筛选">
        <div style={{ marginTop: '20px' }}>
          <FilterBoxes
            form={form}
            onFinish={onFinish}
            onValuesChange={onValuesChange}
            resetButtonProps={{
              onClick: () => {
                form.resetFields();
                setSelectCode({});
                setFormItemState({
                  shopId: false,
                  catdCd: false,
                  brandCode: false,
                });
              },
            }}
          >
            <Form.Item name="shopId" span={6} label="店铺">
              <Select
                allowClear={true}
                showSearch
                disabled={formItemState.shopId}
                filterOption={(input, option) =>
                  (option.children.toLowerCase() + option.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                }
                placeholder="请选择"
              >
                {data.shopList.length > 0 &&
                  data.shopList.map((item, index) => (
                    <Select.Option key={index} value={item.shopId}>
                      {item.shopName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item name="catdCd" span={6} label="品类" rules={[{ validator: validateSelectMax }]}>
              {/* <Cascader
                // disabled={formItemState.cateId}
                fieldNames={{ label: 'name', value: 'value' }}
                disabled={formItemState.catdCd}
                options={data.cateTree}
                placeholder="请选择"
                changeOnSelect
              /> */}

              <Cascader
                options={data.cateTree}
                fieldNames={{ label: 'name', value: 'value' }}
                disabled={formItemState.catdCd}
                multiple
                placeholder="请选择"
                maxTagCount="responsive"
              />

              {/* <TreeSelectDepartment options={data.cateTree} disabled={formItemState.catdCd} /> */}
            </Form.Item>
            <Form.Item name="brandCode" span={6} label="品牌">
              <Select
                allowClear={true}
                showSearch
                disabled={formItemState.brandCode}
                filterOption={(input, option) =>
                  (option.children.toLowerCase() + option.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                }
                placeholder="请选择"
              >
                {data.brandList.length > 0 &&
                  data.brandList.map((item, index) => (
                    <Select.Option key={index} value={item.brandCode}>
                      {item.brandName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </FilterBoxes>
          <div style={{ display: 'flex', height: '96px', marginTop: '28px' }}>
            <div style={{ width: '33%', paddingRight: '16px' }}>
              <div className="core-indecator-data-card">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div className="core-indecator-data-title">
                      引入商详UV
                      <IconTip
                        title="通过活动会场页面进入商详页面的UV去重（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）"
                        type="question"
                        size="small"
                      />
                    </div>
                    <div className="core-indecator-data-value">{formatPrice(dataSource.itemUv) || '-'}</div>
                  </div>
                  <img
                    src="//img30.360buyimg.com/pop/jfs/t1/113764/35/29971/7407/6311d7efE119d3395/2518dff9b805971c.png"
                    width={121}
                    height={28}
                  />
                </div>
              </div>
            </div>
            <div style={{ width: '33%', paddingRight: '16px' }}>
              <div className="core-indecator-data-card">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div className="core-indecator-data-title">
                      直接引导成交订单量
                      <IconTip
                        title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生的订单量为直接引导成交订单量"
                        type="question"
                        size="small"
                      />
                    </div>
                    <div className="core-indecator-data-value">{formatPrice(dataSource.zjParentOrdQtty) || '-'}</div>
                  </div>

                  <img
                    src="//img30.360buyimg.com/pop/jfs/t1/86925/31/31157/6644/6311d7efEf72f5e72/b0e130fe74354796.png"
                    width={121}
                    height={28}
                  />
                </div>
              </div>
            </div>
            <div style={{ width: '33%' }}>
              <div className="core-indecator-data-card">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div className="core-indecator-data-title">
                      直接引导成交订单金额
                      <IconTip
                        title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生的订单金额为直接引导成交订单金额"
                        type="question"
                        size="small"
                      />
                    </div>
                    <div className="core-indecator-data-value">{formatPrice(dataSource.zjOrdAmt) || '-'}</div>
                  </div>
                  <img
                    src="//img30.360buyimg.com/pop/jfs/t1/86925/31/31157/6644/6311d7efEf72f5e72/b0e130fe74354796.png"
                    width={121}
                    height={28}
                  />
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', marginTop: '28px', height: '324px' }}>
            <div style={{ width: '50%', paddingRight: '100px' }}>
              <SkuEffect data={dataSource} />
            </div>
            <div style={{ width: '50%', paddingRight: '100px' }}>
              <UVEffect data={dataSource} />
            </div>
          </div>
        </div>
      </ModuleTitle>
    </div>
  );
};
export default CoreIndicators;
